module.exports = __webpack_public_path__ + "img/japan.4a994bd7.jpg";